import React, { useEffect, useState } from "react";
import { Card, Descriptions, Spin, message, Tag, Badge } from "antd";
import { useParams } from "react-router-dom";
import { UserManagement } from "@/types";
import { apiService } from "@/services/api";

export const UserShow: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [user, setUser] = useState<UserManagement | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      if (!id) return;
      try {
        const data = await apiService.getUser(id);
        setUser(data);
      } catch (e: any) {
        message.error("Impossible de charger l'utilisateur");
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "50px" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!user) {
    return <div>Utilisateur non trouvé</div>;
  }

  return (
    <Card title={`Utilisateur: ${user.username}`}>
      <Descriptions bordered column={1}>
        <Descriptions.Item label="ID">{user.id}</Descriptions.Item>

        <Descriptions.Item label="Nom d'utilisateur">
          {user.username}
        </Descriptions.Item>

        <Descriptions.Item label="Email">
          {user.email}
          {user.emailVerified && (
            <Tag color="green" style={{ marginLeft: 8 }}>
              Vérifié
            </Tag>
          )}
        </Descriptions.Item>

        <Descriptions.Item label="Prénom">
          {user.firstName || "N/A"}
        </Descriptions.Item>

        <Descriptions.Item label="Nom">
          {user.lastName || "N/A"}
        </Descriptions.Item>

        <Descriptions.Item label="Téléphone">
          {user.phone || "N/A"}
        </Descriptions.Item>

        <Descriptions.Item label="Rôles">
          {user.roles && user.roles.length > 0 ? (
            user.roles.map((role) => (
              <Tag key={role} color="blue">
                {role.replace("ROLE_", "")}
              </Tag>
            ))
          ) : (
            "Aucun rôle"
          )}
        </Descriptions.Item>

        <Descriptions.Item label="Statut">
          <Badge
            status={user.enabled ? "success" : "error"}
            text={user.enabled ? "Actif" : "Désactivé"}
          />
        </Descriptions.Item>

        <Descriptions.Item label="Date de création">
          {user.createdTimestamp
            ? new Date(user.createdTimestamp).toLocaleString("fr-FR")
            : "N/A"}
        </Descriptions.Item>

        <Descriptions.Item label="Dernière connexion">
          {user.lastLoginAt
            ? new Date(user.lastLoginAt).toLocaleString("fr-FR")
            : "Jamais"}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default UserShow;
